import { __awaiter } from "tslib";
import { addEventProcessor, getCurrentHub } from '@sentry/core';
import { NATIVE } from '../wrapper';
/** Release integration responsible to load release from file. */
export class Release {
    constructor() {
        /**
         * @inheritDoc
         */
        this.name = Release.id;
    }
    /**
     * @inheritDoc
     */
    setupOnce() {
        addEventProcessor((event) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const self = getCurrentHub().getIntegration(Release);
            if (!self) {
                return event;
            }
            const options = (_a = getCurrentHub().getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
            /*
              Check for the release and dist in the options passed on init.
              Otherwise, we get the release and dist from the native package.
            */
            if (typeof (options === null || options === void 0 ? void 0 : options.release) === 'string') {
                event.release = options.release;
            }
            if (typeof (options === null || options === void 0 ? void 0 : options.dist) === 'string') {
                event.dist = options.dist;
            }
            if (event.release && event.dist) {
                return event;
            }
            try {
                const nativeRelease = yield NATIVE.fetchNativeRelease();
                if (nativeRelease) {
                    if (!event.release) {
                        event.release = `${nativeRelease.id}@${nativeRelease.version}+${nativeRelease.build}`;
                    }
                    if (!event.dist) {
                        event.dist = `${nativeRelease.build}`;
                    }
                }
            }
            catch (_Oo) {
                // Something went wrong, we just continue
            }
            return event;
        }));
    }
}
/**
 * @inheritDoc
 */
Release.id = 'Release';
//# sourceMappingURL=release.js.map